import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs text-ab-muted">
      {items.map((it, i) => (
        <li key={it.path || it.name} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={12} aria-hidden="true" />}
          {i < items.length - 1 ? <Link to={it.path} className="hover:text-ab-accent">{it.name}</Link> : <span aria-current="page" className="text-ab-text-2">{it.name}</span>}
        </li>
      ))}
    </ol>
  </nav>
);
